import { render, staticRenderFns } from "./aboutpage.vue?vue&type=template&id=4262b475&"
import script from "./aboutpage.vue?vue&type=script&lang=js&"
export * from "./aboutpage.vue?vue&type=script&lang=js&"
import style0 from "./aboutpage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports